import React, { useEffect, useRef } from "react";
import { FaMobileAlt } from "react-icons/fa"
//import styled from "styled-components";

import {
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Link,
  Box,
} from "@chakra-ui/core";

// const StlyledSearchWidget = styled.div`
//   border: 1px solid green;
//   padding: 0.5rem;
//   cursor: pointer;
//   margin: 0.1rem;
//   -webkit-transition: all 0.4s ease-in-out;
//   transition: all 0.4s ease-in-out;
//   display: ${props => props.widget? "block" : "none"};

//   &:hover {
//     background-color: green;
//     color: white;
//   }
// `;
/** The searbox field */

const SearchBox = ({
  entity = "",
  searchString,
  setSearchString,
  matches,
  handleSearchedItem,
  widget
}) => {
  const inputRef = useRef("");
  useEffect(() => {
    inputRef.current.focus();
  }, []);
  const clearSearch = (clear) =>{
    if(clear){
      setSearchString('');
    }
  }

  const SearchWidget = ({ match, select, clear, widget, ...otherProps }) => {
    return (
      <Box
        bg="success.transparent-100"
        style={{cursor:"pointer"}}
        mb="1px"
        w="100%"
        px={4}
        py={2}
        color="primary.500"
        key={match.id}
        onClick={() => {select(match); clear(true)}}
        display={ widget ? "block" : "none"}
      >
        <Link _hover={{color:"success.500", fontWeight:"bold"}} >
        {match.firstName} {match.lastName} 
        </Link>   
        <Stack opacity=".7" spacing={1} alignItems="center" isInline>
        <Box as={FaMobileAlt} fontSize="12px" />
        <Box as="span" fontSize="xs">{match.phone || match.email}</Box>
        </Stack>
      </Box>
    );
  };

  return (
    <>
    <Stack my="8px" isInline w="100%" justifyContent="center" margin={props => props.widget? "0" : "5"}>
        <InputGroup width="100%" maxW="600px">
          <InputLeftElement
            children={<Icon name="search" color="primary.500" />}
          />
          <Input
            borderColor="primary.400"
            borderWidth="2px"
            focusBorderColor="success.500"
            maxW="600px"
            type="text"
            placeholder={"Search " + entity}
            value={searchString}
            onChange={(e) => {
              setSearchString(e.target.value);
            }}
            ref={inputRef}
          />
        </InputGroup>
      </Stack>
      {matches &&
        matches.map((match) => (
          <SearchWidget
            key={match.id}
            match={match}
            select={handleSearchedItem}
            clear={clearSearch}
            widget={widget}
          />
        ))}
    </>
  );
};

export default SearchBox;
